"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toyota = void 0;
var _styledComponents = require("styled-components");
var _ToyotaTypography = require("../../../components/ToyotaTypography");
var Styled = _interopRequireWildcard(require("./index.styled"));
const toyota = exports.toyota = (0, _styledComponents.css)`
  ${Styled.TooltipPopper} {
    position: fixed;
    bottom: 0 !important;
    transform: none !important;
    top: unset !important;
    left: 0% !important;
    width: 100% !important;
    display: flex;
    justify-content: center;

    svg {
      display: none;
    }
  }

  ${Styled.TooltipContentWrapper} {
    min-height: 50px;
    min-width: 150px;
    max-width: 880px;
    max-height: 90px;
    --overflow-max-height: 90px;
    --overflow-max-width: 880px;

    width: 100%;
    background: rgba(0, 0, 0, 0.8);
    padding: 0;
  }

  ${Styled.TooltipContent} {
    width: 100%;
    padding: 20px 65px 20px 20px;
    ${(0, _ToyotaTypography.ToyotaType)({
  sizing: "legal01"
})}
  }

  ${Styled.CloseButtonWrapper} {
    right: 20px;
    top: 15px;
  }

  ${Styled.CloseButton} {
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    border: 2px solid #fff;
    border-radius: 100%;
    padding: 0 12px;
    line-height: 0;

    svg {
      display: block;
      stroke: #FFF;
      stroke-width: 5px;
    }
  }
`;